//import from webpack alias appConfig

export const SIZE_TOKEN = 'size';

export const SIZE_TOKENS = [
    'dress-size',
    'shoe-size',
    'pants-size',
    'shirt-size',
];

export const SAVED_ITEMS_SUB_MENU_PAGES = [
    {
        number: 1,
        href: '/saved-outfits',
        title: 'Saved Outfits'
    },
    {
        number: 2,
        href: '/saved-items',
        title: 'Saved Items'
    }
];
export const LANDING_MENU_PAGES = [
    {
        number: 1,
        href: '/',
        title: 'Personal Styling'
    },
    {
        number: 2,
        href: '/featured-outfits',
        title: 'Featured Outfits'
    }
];

export const RETURN_PAGE_SAVED_ITEMS = {
    href: '/saved-items',
    title: 'Back to Saved Items'
};

export const RETURN_PAGE_SAVED_OUTFITS = {
    href: '/saved-outfits/outfit',
    title: 'Back to Saved Outfit'
};

export const RETURN_PAGE_GET_STYLED = {
    href: '/get-styled',
    title: 'Back to Outfit'
};

export const OUTFIT_TYPES = {
    FEATURED: 'featured',
    GENERATED: 'generated',
    SAVED: 'saved',
    CART: 'cart',
    QUIZ: 'quiz',
};

export const MAX_PRICE = 9999999999;
export const MIN_PRICE = 0;

export const SEASON_FILTER = 'season';
export const OCCASION_FILTER = 'occasion';
export const PRICE_FILTER = 'budget';
export const SORT_FILTER = 'sort';

export const FILTERS = [
    SEASON_FILTER,
    OCCASION_FILTER,
    SORT_FILTER,
];

export const PAGES_USING_FILTERS = [
    'shop',
    'get-styled',
    'saved-outfits'
];

export const FILTER_PAGE = '/outfit/filters';

export const NON_SCROLLABLE_PAGES = [
    '/login'
];

export const SCREEN_NAMES_ANALYITICS = {
    SEARCH: {
        'search-landing': 'search home',
        'search-result': 'search results',
        'brands-list': 'search brands',
        'product-view': 'search product detail',
    },
    PROFILE: {
        'main-menu': 'profile home',
        'my-orders': 'user orders',
        'style-settings': 'style settings',
        'account-settings': 'account settings',
    }
}